<template>
    <gridComponent :loader="loader" :items="items" :itemsData="itemsData" :headers="headers"
        :ColonneWidth="['20%', '20%', '20%', '12%', '12%', '8%']" :GetFunction="getMasterOrderDetails" :action="false">
        <!-- Filters -->
        <template v-slot:[SlotsFilters.Filter0]>
            <ColumnFilter :title="$t('masterOrders.MasterOrderDetails.orderNumber')" :Filter="OrderNumber"
                @cancel="OrderNumber = null" :getList="getMasterOrderDetails">
                <template v-slot:input>
                    <v-text-field v-model="OrderNumber" id="OrderNumber" variant="outlined" maxlength="33"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter1]>
            <ColumnFilter :title="$t('masterOrders.MasterOrderDetails.clientName')" :Filter="ClientName"
                @cancel="ClientName = null" :getList="getMasterOrderDetails">
                <template v-slot:input>
                    <v-text-field v-model="ClientName" variant="outlined" maxlength="33" hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter2]>
            <ColumnFilter :title="$t('masterOrders.MasterOrderDetails.creationDate')" :Filter="CreationDate"
                @cancel="CreationDate = null" :getList="getMasterOrderDetails">
                <template v-slot:input>
                    <span lang="en-CA" xml:lang="en-CA">
                        <dateField v-model="CreationDate" :min-date="new Date('2000-01-01')" :max-date="new Date()" />
                    </span>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter3]>
            <ColumnFilter :title="$t('masterOrders.MasterOrderDetails.totalQuantity')" :Filter="TotalQuantity"
                @cancel="TotalQuantity = null" :getList="getMasterOrderDetails">
                <template v-slot:input>
                    <v-text-field v-model="TotalQuantity" variant="outlined" type="number" hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter4]>
            <ColumnFilter :title="$t('masterOrders.MasterOrderDetails.totalAmount')" :Filter="TotalAmount"
                @cancel="TotalAmount = null" :getList="getMasterOrderDetails">
                <template v-slot:input>
                    <v-text-field v-model="TotalAmount" variant="outlined" type="number" hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter5]>
            <ColumnFilter :title="$t('masterOrders.MasterOrderDetails.status')" :Filter="Status" @cancel="Status = null"
                :getList="getMasterOrderDetails">
                <template v-slot:input>
                    <v-radio-group v-model="Status" column>
                        <v-radio :label="$t('masterOrders.MasterOrderDetails.statusList.pending')" :value="0"></v-radio>
                        <v-radio :label="$t('masterOrders.MasterOrderDetails.statusList.assigned')"
                            :value="1"></v-radio>
                        <v-radio :label="$t('masterOrders.MasterOrderDetails.statusList.inTransit')"
                            :value="2"></v-radio>
                        <v-radio :label="$t('masterOrders.MasterOrderDetails.statusList.delivered')"
                            :value="3"></v-radio>
                        <v-radio :label="$t('masterOrders.MasterOrderDetails.statusList.cancelled')"
                            :value="4"></v-radio>
                        <v-radio :label="$t('masterOrders.MasterOrderDetails.statusList.collected')"
                            :value="5"></v-radio>
                    </v-radio-group>
                </template>
            </ColumnFilter>
        </template>

        <!-- Data Rows -->
        <template v-slot:[SlotsItems.item0]="{ item }">{{ item.numCommand }}</template>
        <template v-slot:[SlotsItems.item1]="{ item }">{{ item.client?.fullName || "N/A" }}</template>
        <template v-slot:[SlotsItems.item2]="{ item }">{{ formatDate(item.createdDate) }}</template>
        <template v-slot:[SlotsItems.item3]="{ item }">{{ item.quantity }}</template>
        <template v-slot:[SlotsItems.item4]="{ item }">{{ formatPrice(item.totalPriceTTC) }}</template>
        <template v-slot:[SlotsItems.item5]="{ item }">
            <StatusButton v-if="item" :title="getStatusText(item.status)" :color="getStatusColor(item.status)" />
        </template>

    </gridComponent>
</template>

<script>
import gridComponent from "@/genericComponent/gridComponent.vue";
import ColumnFilter from "@/genericComponent/ColumnFilter.vue";
import dateField from "@/genericComponent/date-field.vue";
import StatusButton from "@/genericComponent/StatusButton.vue";
import { formatPrice, getMasterOrderById } from "@/api/index";

export default {
    components: {
        gridComponent,
        ColumnFilter,
        dateField,
        StatusButton,
    },
    props: {
        masterOrderId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            durationModel: {
                years: 0,
                months: 0,
                days: 0,
                hours: 0,
                minutes: 0
            },
            loader: true,
            page: 1,
            pageSize: 10,
            items: [],
            itemsData: {},
            search: null,
            OrderNumber: null,
            ClientName: null,
            TotalQuantity: null,
            Status: null,
            TotalAmount: null,
            CreationDate: null,
            CollectionTime: null,
            SortedBy: null,
            SortingType: null

        };
    },
    created() {
        this.getMasterOrderDetails();
    },
    mounted() {
        this.emitter.off("event-test");
        this.emitter.emit("remise-search-at-null");
        this.emitter.on("event-test", (event) => {
            this.search = event;
            this.getMasterOrderDetails();
        });
    },
    unmounted() {
        this.emitter.off("event-test");
        this.emitter.emit("remise-search-at-null");
    },
    methods: {
        formatPrice(price) {
            return formatPrice(price)
        },
        resetDuration() {
            this.CollectionTime = null;
            this.durationModel = {
                years: 0,
                months: 0,
                days: 0,
                hours: 0,
                minutes: 0
            };
        },
        onDurationChange(durationData) {

            this.CollectionTime = {
                value: durationData.formattedDuration,
                dateTimeUtc: durationData.dateTimeUtc,
                dateTimeTicks: durationData.dateTimeTicks,
                duration: {
                    years: durationData.years,
                    months: durationData.months,
                    days: durationData.days,
                    hours: durationData.hours,
                    minutes: durationData.minutes
                }
            };
        },
        onCancelEndCollectionTime() {
            this.CollectionTime = null;
            this.durationModel = {
                years: 0,
                months: 0,
                days: 0,
                hours: 0,
                minutes: 0
            };
        },
        getMasterOrderDetails(page) {
            if (page) {
                this.page = page;
            }
            getMasterOrderById(
                this.masterOrderId,
                this.page,
                this.pageSize,
                this.SortedBy,
                this.SortingType,
                this.search,
                this.Status,
                this.CreationDate,
                this.OrderNumber,
                this.ClientName,
                this.TotalAmount,
                this.TotalQuantity
            ).then((response) => {
                this.items = response.data.items;
                this.itemsData.numberOfPage = response.data.totalPages;
                this.itemsData.totalItemsCount = response.data.totalCount;
                this.itemsData.pageNumber = response.data.pageNumber;
                this.itemsData.hasPreviousPage = response.data.hasPreviousPage;
                this.itemsData.hasNextPage = response.data.hasNextPage;
                this.loader = false;
            });
        },
        onSearch(searchTerm) {
            this.search = searchTerm;
            this.getMasterOrderDetails();
        },
        getStatusText(status) {
            return this.$t(`masterOrders.MasterOrderDetails.statusList.${this.getStatusKey(status)}`);
        },
        getStatusColor(status) {
            switch (status) {
                case 0:
                    return "#C5CDD4";
                case 1:
                    return "#114EF7";
                case 2:
                    return "#FF8934";
                case 3:
                    return "#00CBA0";
                case 4:
                    return "#F25C5C";
                case 5:
                    return "#3BBAFF";
                default:
                    return "#C5CDD4"; // Default Gray
            }
        },
        getStatusKey(status) {
            switch (status) {
                case 0: return "pending";
                case 1: return "assigned";
                case 2: return "inTransit";
                case 3: return "delivered";
                case 4: return "cancelled";
                case 5: return "collected";
                default: return "unknown";
            }
        },
        formatDate(dateString) {

            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            const utcDateString = dateString.replace(' ', 'T') + 'Z';
            const utcDate = new Date(utcDateString);

            const localDate = new Date(utcDate.toLocaleString('en-US', { timeZone: userTimeZone }));

            const year = localDate.getFullYear();
            const month = String(localDate.getMonth() + 1).padStart(2, '0');
            const day = String(localDate.getDate()).padStart(2, '0');
            const hours = String(localDate.getHours()).padStart(2, '0');
            const minutes = String(localDate.getMinutes()).padStart(2, '0');
            const seconds = String(localDate.getSeconds()).padStart(2, '0');
            const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;

            return formattedDateTime;
        },
    },
    computed: {
        headers() {
            return [
                this.$t("masterOrders.MasterOrderDetails.orderNumber"),
                this.$t("masterOrders.MasterOrderDetails.clientName"),
                this.$t("masterOrders.MasterOrderDetails.creationDate"),
                this.$t("masterOrders.MasterOrderDetails.totalQuantity"),
                this.$t("masterOrders.MasterOrderDetails.totalAmount"),
                this.$t("masterOrders.MasterOrderDetails.status")
            ];
        },
        SlotsItems() {
            const items = {
                item0: "item",
                item1: "item",
                item2: "item",
                item3: "item",
                item4: "item",
                item5: "item",
            };
            let i = 0;
            for (const key in items) {
                items[key] = "item" + i;
                i = i + 1;
            }
            return items;
        },
        SlotsFilters() {
            const filters = {
                Filter0: "Filter",
                Filter1: "Filter",
                Filter2: "Filter",
                Filter3: "Filter",
                Filter4: "Filter",
                Filter5: "Filter",
            };
            let i = 0;
            for (const key in filters) {
                filters[key] = "Filter" + i;
                i = i + 1;
            }
            return filters;
        },
    },
    watch: {
        search() {
            this.getMasterOrderDetails();
        },
    },
};
</script>

<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.text-basil {
    color: #114ef7 !important;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    font-family: inter;
}

.slider {
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    border-bottom: "2px solid black";
}

.disabled {
    opacity: 0.5;
    pointer-events: none;
}
</style>
